import { combineReducers } from 'redux';

import { reducer as addresses } from './addressesReducer';

export default combineReducers({
  addresses,
});
